document.addEventListener('DOMContentLoaded', () => {
    const popups = document.querySelectorAll('.popup');
    
    popups.forEach(modal => {
        if (!modal) return;
        
        const modalContent = modal.querySelector('.popup__content');
        const closeButton = modal.querySelector('.popup__content--close-btn');
        const isExitModal = modal.classList.contains('isExitPopup');
        const isScrollModal = modal.classList.contains('isScrollPopup');
        const modalDelay = modal.dataset.delay;
        
        // Handle close button click for all modal types
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                modal.style.display = 'none';
            });
        }

        // Standard popup with delay
        if (!isExitModal && !isScrollModal) {
            handleStandardPopup(modal, modalDelay);
        }
        
        // Exit intent popup
        if (isExitModal) {
            handleExitPopup(modal, modalDelay);
        }
        
        // Scroll triggered popup
        if (isScrollModal) {
            handleScrollPopup(modal);
        }
    });
});

function handleStandardPopup(modal, delay) {
    if (delay !== undefined) {
        const delayTime = parseInt(delay);
        if (delayTime > 0) {
            setTimeout(() => {
                modal.style.display = 'flex';
            }, delayTime);
        }
    } else {
        modal.style.display = 'flex';
    }
}

function handleExitPopup(modal, delay) {
    modal.style.display = 'none';
    let hasShown = false;
    
    window.addEventListener('mouseout', (e) => {
        if (!hasShown && e.clientY < 50) {
            hasShown = true;
            if (delay) {
                setTimeout(() => {
                    modal.style.display = 'flex';
                }, parseInt(delay));
            } else {
                modal.style.display = 'flex';
            }
        }
    });
}

function handleScrollPopup(modal) {
    let hasShown = false;
    modal.style.display = 'none';
    
    window.addEventListener('scroll', () => {
        if (hasShown) return;
        
        const scrollPosition = window.scrollY;
        const scrollDistance = modal.dataset.scrollDistance;
        
        if (scrollPosition > parseInt(scrollDistance)) {
            hasShown = true;
            modal.style.display = 'flex';
        }
    });
}